/*
 *  I04DIMPUISCONSCalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-10 17:12:31 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchDegreJourUnifie } from '@batical/data/src'
import { I04DIMPUISCONS_State } from '@batical/types/src'
//RRendementProductionSchema_Type
function I04DIMPUISCONS_docalcul(state: I04DIMPUISCONS_State) {
  let selecteddju_uuid = fetchDegreJourUnifie(state.dju_uuid)
  //TODO CALCUL

  //(Affichage!D16*24-Affichage!C20*Affichage!C21*Affichage!C19)/(Affichage!D16*24)
  state.res_intermittence =
    (selecteddju_uuid.average * 24 - state.in_tempsReduit * state.in_deltaTemperatureAbaissement * state.in_nbJourChauffe) /
    (selecteddju_uuid.average * 24)

  // =(C15*C14)*(C18-C19)/24/(C17+(C18-18)*C20):
  state.res_deperdition =
    (state.in_rendementProduction1 * state.in_consommation * (state.in_consigneT - state.in_temperatureBase)) /
    24 /
    (selecteddju_uuid.average + (state.in_consigneT - 18) * state.in_nbJourChauffe)

  //=C25*D16/2300*230/C19/C24: :state
  state.res_besoinChauffage = state.res_deperdition / state.res_intermittence / state.in_rendementProduction2
  state.invalidated = false
  return state
}

export default I04DIMPUISCONS_docalcul
